import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useParams } from 'react-router-dom';
import { useSearchInput } from 'hooks/useSearchInput';
import { useTransactionFilter } from 'shared/transactionFilterContext';

export const GET_TRACK_TRANSACTIONS_GET_EVENT = gql`
  query GetTrackTransactionsGetEvent(
    $getTrackTransactionsInput: TransactionListInput!
    $getEventInput: GetEventInput!
  ) {
    getTrackTransactionsV2(input: $getTrackTransactionsInput) {
      count
      results {
        id
        fee
        total
        refund
        subtotal
        discount
        credit
        subtotal
        transfer_id
        charge_id
        card {
          last4
        }
        purchase_date
        status
        user {
          id
          name
          first_name
          last_name
          formatted_name
        }
        users {
          promo
          user {
            id
            name
            first_name
            last_name
          }
          tickets {
            id
            name
            price
            refunded
            type
            barcode
            credited
            section
            row
            seat
          }
        }
        international_fee
        order_source
        payment_method
        register
      }
    }
    getEvent(input: $getEventInput) {
      id
      track_id
      image
      month
      day
      date
      added_by
      eventDates
      off_sale_time
      listDates
      isMultiDay
      fullMonth
      image_id
      logo
      logo_id
      name
      start_date
      end_date
      user_id
      sale_start
      sale_end
      about
      admin_website_url
      admin_schedule_url
      off_sale_time
      twitter
      facebook
      instagram
      fullDate
      fullMonth
      hide_fee
      admin_times {
        id
        event_date
        start_time
        gate_time
      }
      user {
        id
        first_name
        last_name
        middle_name
      }
      waivers {
        id
        name
      }
      admin_tickets {
        id
        color_code
        end_date
        isMultiDay
        start_date
        name
        price
        date
        start_time
        gate_time
        limit
      }
      admin_multiday_tickets {
        id
        end_date
        start_date
        color_code
        name
        price
        limit
      }
      admin_other_tickets {
        id
        name
        price
        end_date
        start_date
        color_code
        limit
      }
      status
      series_ids
      series {
        id
        name
      }
      track {
        id
        name
      }
      color_code
      faqs {
        id
        question
        answer
      }
      sales
    }
  }
`;

export function useGetTrackTransactionsGetEvent() {
  const { input } = useSearchInput();
  const { id } = useParams();
  const {
    startDateFilter,
    endDateFilter,
    sortBy,
    source,
    userType,
    paymentMethod,
    deliveryMethod,
  } = useTransactionFilter();
  const { queryString, page } = input;

  return useQuery(GET_TRACK_TRANSACTIONS_GET_EVENT, {
    variables: {
      getTrackTransactionsInput: {
        event_id: Number(id),
        ...(page ? { page } : null),
        ...{ queryString },
        ...(startDateFilter ? { start_date: startDateFilter } : null),
        ...(endDateFilter ? { end_date: endDateFilter } : null),
        ...(sortBy ? { sortBy: sortBy?.value } : null),
        ...(source ? { source: source?.value } : null),
        ...(userType ? { user_type: userType?.value } : null),
        ...(paymentMethod ? { payment_method: paymentMethod?.value } : null),
        ...(deliveryMethod ? { delivery_method: deliveryMethod?.value } : null),
      },
      getEventInput: {
        id: Number(id),
      },
    },
  });
}
